module.exports = __webpack_public_path__ + "img/icon-sleep-time-5.e65e477d.svg";